
// tslint:disable-next-line: class-name
export class exC2DComponent {
    public static classType = m4m["exC2DComponent"] = exC2DComponent;
    public cmop: string = "";

}
